import type { LeadCarteira } from '@/hooks/useLeadsCarteira';
import { LeadDados360Oi } from './LeadDados360Oi';

// Mesmo componente e hierarquia aprovados para Oi; a demanda continua específica da Algar.
export function LeadDados360Algar(props: { lead: LeadCarteira; onLigar: (telefone: string) => void; campanhaNome?: string | null }) {
  return <LeadDados360Oi {...props} variante="ALGAR" />;
}
